import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AchievementDetailDTO } from "src/app/data/schema/Gamification/AchievementDetail/AchievementDetailDTO";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-achievement-player-dialog",
    templateUrl: "./achievement-player-dialog.component.html",
    styleUrls: ["./achievement-player-dialog.component.scss"]
})
export class AchievementPlayerDialogComponent {
    @Input() detail: AchievementDetailDTO;
    @Output() closeMeEvent = new EventEmitter();

    constructor(private _translateService: TranslateService) {
        this._translateService.setTranslation("pt-BR", ptBR, true);
        this._translateService.setTranslation("en-US", enUS, true);
        this._translateService.setTranslation("es-ES", esES, true);
    }

    closeDialog(): void {
        this.closeMeEvent.emit();
    }
}
